import { fromJS } from 'immutable';

import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import * as runsActions from '../actions/runs';

import { fetchingState } from '@constants';
const initialState = {
  auditRuns: { data: [], state: null },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {

    case runsActions.FETCH_EXEMPTION_AUDIT_RUNS[START]:
      return state.setIn(['auditRuns', 'state'], fetchingState.FETCHING);
    case runsActions.FETCH_EXEMPTION_AUDIT_RUNS[SUCCESS]:
      return state
        .setIn(
          ['auditRuns', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(['auditRuns', 'state'], fetchingState.LOADED);
    case runsActions.FETCH_EXEMPTION_AUDIT_RUNS[ERROR]:
      return state.setIn(['auditRuns', 'state'], fetchingState.ERROR);

    default:
      return state;
  }
};
